export class ConsentDto {
    constructor(name, text) {
        this.name = name;
        this.text = text;
    }
}
